<template>
    <div v-if="type === 'select'"
         class="select-box">
        <select
            class="w-full"
            :class="{placeholder: value === null}"
            :autocomplete="autocomplete"
            @input="v => $emit('input', v.target.value)"
            :value="value">
            <option v-if="!disableUnSelect" disabled :value="null">選択してください</option>
            <option v-for="option in options" :value="option.value">{{ option.label }}</option>
        </select>
    </div>
    <input
        v-else-if="type === 'checkbox'"
        type="checkbox"
        :autocomplete="autocomplete"
        :checked="value"
        @input="v => $emit('input', v.target.checked ? trueValue : falseValue)">
    <input
        v-else
        :type="type"
        :autocomplete="autocomplete"
        v-model="localValue"
        :placeholder="placeholder">
</template>

<script>
export default {
    name: "FormInput",
    props: {
        type: {
            type: String,
            default: 'text'
        },
        value: {
            type: String | Number | Boolean,
        },
        placeholder: {
            type: String
        },
        options: {
            type: Array
        },
        disableUnSelect: {
            type: Boolean,
            default: false
        },
        autocomplete: {
            type: String
        },
        trueValue: {
            type: String | Number | Boolean,
            default: 1
        },
        falseValue: {
            type: String | Number | Boolean,
            default: 0
        },
        halfWidth: {
            type: Boolean,
            default: false,
        }
    },

    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(value) {
                if (this.halfWidth) {
                    this.$emit('input', value.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
                        return String.fromCharCode(s.charCodeAt(0) - 65248)
                    }));
                } else {
                    this.$emit('input', value);
                }
            }
        }
    }
}
</script>

<style scoped>

</style>
